import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { addCommaToNumber } from "utils";
import {
  setWorkflowFilter,
  searchAnalyticsDropdownWorkflow,
  resetWorkflowSearch,
  selectWorkflow,
  reorderWorkflows
} from "../Dashboard/actions";
import { IWorkflowDropdownItem } from "../interfaces";
import { WFStatusEnum } from "../../Automation/interfaces";
import SelectFilterWithIcon from "./SelectFilterWithIcon";
import workflowIcon from "../../../assets/img/icons/Campaign/workflowGrey.svg";


interface IWorkflowFiltersDropdown {
}

const WorkflowFiltersDropdown: React.FC<IWorkflowFiltersDropdown> = (props) => {
  const [isFirstReordered, setIsFirstReordered] = useState(false);
  // redux states
  const workflows = useSelector((state: RootState) => state.analyticsDashboard.workflows);
  // const filteredWorkflows = useSelector((state: RootState) => state.analyticsDashboard.filteredWorkflows);
  // const searchedWorkflows = useSelector((state: RootState) => state.analyticsDashboard.searchedWorkflows);
  const selectedWorkflowsIds = useSelector((state: RootState) => state.analyticsDashboard.selectedWorkflowsIds);
  const workflowFilters = useSelector((state: RootState) => state.analyticsDashboard.workflowFilters);
  const workflowSearchTerm = useSelector((state: RootState) => state.analyticsDashboard.workflowSearchTerm);
  const workflowsLoading = useSelector((state: RootState) => state.analyticsDashboard.workflowsLoading);
  const campaignsLoading = useSelector((state: RootState) => state.analyticsDashboard.campaignsAssetsLoading);
  const firstAllDataShown = useSelector((state: RootState) => state.analyticsDashboard.firstAllDataShown);

  const getItems = () => {
    let filteredWorkflows;
    filteredWorkflows = workflows.filter((workflow: IWorkflowDropdownItem) => workflow.name?.toLowerCase()?.includes(workflowSearchTerm?.toLowerCase()));

    if (workflowFilters.isAllType) {
      return filteredWorkflows;
    } else if (workflowFilters.isActive) {
      return filteredWorkflows.filter((item: any) => item.status === WFStatusEnum.ACTIVE);
    } else if (workflowFilters.isInactive) {
      return filteredWorkflows.filter((item: any) => item.status === WFStatusEnum.INACTIVE);
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (workflows?.length > 0 && !isFirstReordered) {
      if (selectedWorkflowsIds?.length > 0) {
        reorderWorkflows();
        setIsFirstReordered(true);
      }
    }
  }, [workflows.length, selectedWorkflowsIds.length]);


  return (
    <SelectFilterWithIcon
      label={
        selectedWorkflowsIds.length > 0
          ? `${addCommaToNumber((selectedWorkflowsIds?.length ?? 0).toString() ?? "")} Workflow(s) selected`
          : "Workflows"
      }
      icon={workflowIcon}
      searchTitle="Search workflows..."
      filterTitle="Filter Workflows"
      filters={workflowFilters}
      idPrefix="workflow-01"
      items={getItems()}
      onSearchInput={(value: any) => {
        searchAnalyticsDropdownWorkflow(value);
      }}
      setCheckBox={(value: boolean) => setWorkflowFilter(value)}
      setSelected={(value: IWorkflowDropdownItem) => selectWorkflow(value.id)}
      selectedItems={selectedWorkflowsIds}
      onClearSearch={resetWorkflowSearch}
      dropdownClass={`dropdown-menu-wrapper`}
      dropdownType='Workflows'
      onClose={() => {
        reorderWorkflows();
      }}
      showSentBy
      hideShareProfile
      hideDailyIQ
      hideWeeklyAccountInsights
      loading={campaignsLoading}
      disableDropdown={!firstAllDataShown}
    />
  );
}

export default WorkflowFiltersDropdown;
